import { configureStore } from "@reduxjs/toolkit";
import user from "./slices/user";
import usersManagement from "./slices/user_management";
import trails from "./slices/trails";
import subjectTrails from "./slices/subject-trails";
import chatTrails from "./slices/chat-trails";
import aiCalls from "./slices/ai-calls";
import scenarioTrails from "./slices/scenario-trails";
import messageAnalytics from "./slices/message-analytics";
import onboardingSurveyAnalytics from "./slices/onboarding-survey-analytics";
import articleEngagements from "./slices/article-engagements";
import taskAnalytics from "./slices/task-analytics";
import settings from "./slices/settings";
import projects from "./slices/projects";
import permissions from "./slices/permissions";

const reducer = {
  user,
  usersManagement,
  trails,
  subjectTrails,
  scenarioTrails,
  messageAnalytics,
  onboardingSurveyAnalytics,
  articleEngagements,
  taskAnalytics,
  chatTrails,
  aiCalls,
  settings,
  projects,
  permissions,
};

export default configureStore({ reducer });
